import Handsontable from 'handsontable'
import { NestedRows } from 'handsontable/plugins'
import { cn } from '@global/utils/tailwind'
import { TranslationStatus } from '@taxonomy-translation/types'

const STATUS_CONFIG: Record<TranslationStatus, { label: string; bg: string }> = {
  [TranslationStatus.Match]: {
    label: 'match',
    bg: 'bg-[rgba(124,205,161,0.3)]',
  },
  [TranslationStatus.NoMatch]: {
    label: 'no match',
    bg: 'bg-[rgba(228,27,12,0.2)]',
  },
  [TranslationStatus.Reviewed]: {
    label: 'reviewed',
    bg: 'bg-[rgba(62,143,247,0.2)]',
  },
  [TranslationStatus.Excluded]: {
    label: 'excluded',
    bg: 'bg-[rgb(202,216,222)]',
  },
} as const

export const statusColumnRenderer = (
  instance: Handsontable,
  td: HTMLTableCellElement,
  row: number,
  _col: number,
  _prop: string,
  status: TranslationStatus,
  cellProperties: Handsontable.CellProperties,
) => {
  try {
    const nestedRowsPlugin = instance.getPlugin('nestedRows') as NestedRows & { collapsingUI: any }
    const rowObject = instance.getSourceDataAtRow(row)

    if (!rowObject) {
      return td
    }

    let isCollapsed = false

    try {
      const dataObject = nestedRowsPlugin.collapsingUI.dataManager.getDataObject(row)
      if (dataObject) {
        isCollapsed = nestedRowsPlugin.collapsingUI.isAnyParentCollapsed(dataObject)
      }
    } catch (e) {
      console.warn('Error checking parent collapse state:', e)
    }

    if (isCollapsed) {
      cellProperties.hidden = true
      return td
    }

    cellProperties.hidden = false

    while (td.firstChild) {
      td.removeChild(td.firstChild)
    }

    if (status && STATUS_CONFIG[status]) {
      const config = STATUS_CONFIG[status]

      // Create the outer container
      const container = document.createElement('div')
      container.className = 'w-full h-full flex items-center justify-start'

      // Create the badge element
      const badge = document.createElement('div')
      badge.className = cn('px-2 rounded-[10px] my-3', config.bg)
      badge.textContent = config.label
      container.appendChild(badge)
      td.appendChild(container)
    }
  } catch {
    // ignore
  }

  return td
}
